<template>
  <div class="container_box">
    <!--扫描上架-->
    <div class="filter_box">
      <Form :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004070')">
              <Input
                :disabled="!getPermission('ymsContainerStatus_startShelves')"
                :element-id="'scanning'"
                :placeholder="$t('key1004071')"
                @on-enter="enterScanInput"
                prefix="icon-scan"
                clearable
                v-model.trim="code">
              </Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002400')" prop="codeList">
              <Input type="textarea" :placeholder="$t('key1004072')"
                v-model.trim="pageParams.codeList"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.status !== 6">
            <Form-item :label="$t('key1003158')" prop="workBy">
              <Select v-model="pageParams.workBy" style="width: 200px;" filterable>
                <Option v-for="item in updatedByList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="dropDownTimeList.length>0">
            <dropDownDateTime
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="content_box">
      <div class="flex align-items-center justify-content-between mb20">
        <div class="sort_options_box">
          <span>{{ $t('key1004074') }}</span>
          <local-tabButton :tabButtonList="containerStatusList" @selectStatus="containerStatusBtn"></local-tabButton>
        </div>
        <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsContainerStatus_shelvesOrderExport')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="table_box">
        <Table
          ref="selection"
          highlight-row
          border
          max-height="500"
          :loading="tableLoading"
          :columns="tableColumns"
          @on-selection-change="tableChange"
          :data="tableData">
        </Table>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1004073')"
      paramKeyColums="ymsContainerShelvesOrderExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--商品上架弹窗-->
    <commodityShelvesModal ref="commodityShelves" @updateData="pageParamsStatus = true"></commodityShelvesModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownDateTime from "@/components/common/dropDownDateTime";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import commodityShelvesModal from "@/views/yms/components/collectionManage/commodityShelvesModal";
import {getUserNameByUserId, pageJump, setConfigCharacters, getYmsUserWarehouseOpersUserName, getEnableWarehouseData, getAllUsersInfo} from "@/utils/common";

export default {
  name: "commodityShelves",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      code: '',
      pageParams: {
        codeList: '',
        status: 0,
        workBy: null,
        workEndTimeDown: null,
        workEndTimeUp: null,
        workStartTimeDown: null,
        workStartTimeUp: null,
        ymsWarehouseId: 'null', // 所属仓库
        ymsContainerStatusIds: [],
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      shelvesTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.containerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: `${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695')}`,
          key: 'skuQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'quantity',
          sortable: true,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000593'),
                    show: v.getPermission('ymsContainerStatus_shelvesDetail'),
                    clickFn: () => {
                      let url = api.get_ymsContainerStatus_shelvesDetail + `?ymsContainerStatusId=${params.row.ymsContainerStatusId}`;
                      v.$refs['commodityShelves'].initCommodityShelvesData(url);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 待上架
      shelvesingTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.containerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: `${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695')}`,
          key: 'skuQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'quantity',
          sortable: true,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'operationTime',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.operationTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'operationUserId',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.operationUserId, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 150,
          render(h, params) {
            let talg = v.userInfo.userId === params.row.operationUserId && v.getPermission('ymsContainerStatus_shelvesDetail');
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004055'),
                    show: talg,
                    clickFn: () => {
                      let url = api.get_ymsContainerStatus_shelvesDetail + `?ymsContainerStatusId=${params.row.ymsContainerStatusId}`;
                      v.$refs['commodityShelves'].initCommodityShelvesData(url);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 上架中
      shelvesedTableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let text = '';
            v.containerStatusList.map((item) => {
              if (item.value === params.row.status) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: `${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695')}`,
          key: 'skuQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004053'),
          key: 'quantity',
          sortable: true,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004056'),
          key: 'shelvesQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'operationTime',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.operationTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'),
          key: 'operationEndTime',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.operationEndTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058'),
          key: 'timer',
          align: 'center',
          render: (h, params) => {
            let startTime = v.$uDate.dealTime(params.row.operationTime, 'fulltime');
            let endTime = v.$uDate.dealTime(params.row.operationEndTime, 'fulltime');

            if (endTime && startTime) {
              let timeStamp = (new Date(endTime).getTime() - new Date(startTime).getTime()) / 1000;
              return h('span', v.$uDate.timeStampTime(timeStamp));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'operationUserId',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.operationUserId, v.userInfoList));
          }
        }
      ], // 已上架
      updatedByList: [],
      defaultSelectValue: 1,
      dropDownTimeList: [],
      containerStatusList: [],
      warehouseList: [],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004059')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004060')}
      ],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'code', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004052')},
            {paramKey: 'ymsSku', paramValue: 'SKU'},
            {paramKey: 'skuQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004061')},
            {paramKey: 'goodsQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004062')},
            {paramKey: 'ymsWarehouseLocation', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004063')},
            {paramKey: 'shelvesQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004056')},
            {paramKey: 'shelvesOrderStartTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054')},
            {paramKey: 'shelvesOrderEndTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057')},
            {paramKey: 'dateLength', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004058')},
            {paramKey: 'updatedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')},
          ]
        }
      ],
      userInfoList: {}
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanning');
    });
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.updatedByList = [];
      let roleList = this.$store.state.roleList;
      let newList = [];
      let list = [
        {selected: false, value: 6, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004064'), jurisdictionKey: 'ymsContainerStatus_queryWaitingShelves'},
        {selected: false, value: 7, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004065'), jurisdictionKey: 'ymsContainerStatus_queryShelvesing'},
        {selected: false, value: 8, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004066'), jurisdictionKey: 'ymsContainerStatus_queryShelved'},
      ];
      list.map((item) => {
        if (roleList[item.jurisdictionKey]) {
          newList.push(item);
        }
      });
      list[0].selected = true;
      this.containerStatusList = list;
      this.warehouseList = [];
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await getEnableWarehouseData(1).then((data) => {
          if (data.length > 0) {
            this.warehouseList = [{ymsWarehouseId: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')}, ...data];
          }
        });
        // 查询商户下拥有所有授权仓库的用户
        await getYmsUserWarehouseOpersUserName(this.userInfo.userId).then((data) => {
          if (data) {
            for (let key in data) {
              this.updatedByList.push(data[key]);
            }
          }
        });
        if (this.getPermission('ymsContainerStatus_queryWaitingShelves')) {
          this.pageParams.status = 6;
          await this.getShelvesList();
        } else if (this.getPermission('ymsContainerStatus_queryShelvesing')) {
          this.pageParams.status = 7;
          await this.getShelvesingList();
        } else if (this.getPermission('ymsContainerStatus_queryShelved')) {
          this.pageParams.status = 8;
          await this.getShelvesedList();
        }
        await this.getShelvesOptions();
      })();
    },
    // 提货单号的回车键
    enterScanInput() {
      let v = this;
      if (v.code !== '') {
        let url = api.get_ymsContainerStatus_startShelves + `?code=${v.code}`;
        v.$refs['commodityShelves'].initCommodityShelvesData(url);
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004067'));
        return false;
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.codeList = v.sepCommasFn(v.pageParams.codeList, [',', '，', '\n']);
      params.ymsWarehouseId = v.pageParams.ymsWarehouseId === 'null' ? null : v.pageParams.ymsWarehouseId;
      return params;
    },
    // 获取待上架数据
    getShelvesList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryWaitingShelves')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryWaitingShelves, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取上架中数据
    getShelvesingList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryShelvesing')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryShelvesing, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取已上架数据
    getShelvesedList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsContainerStatus_queryShelved')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsContainerStatus_queryShelved, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.code = '';
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      if (v.pageParams.status === 8) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.pageParamsStatus = true;
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs['dropDownDateTime'] ? this.$refs['dropDownDateTime'].timeList = [] : '';
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 选取容器状态
    containerStatusBtn(index, value) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.status = value;
      v.containerStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
      if (v.pageParams.status === 8) {
        v.changeInput(1);
        setTimeout(() => {
          v.setDefaultTimerParams('three_months', 1);
          v.pageParamsStatus = true;
        }, 500);
      } else {
        v.changeInput(1);
        v.pageParamsStatus = true;
      }
      v.$forceUpdate();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsContainerStatusId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsContainerStatusIds = v.selectTableData;
      } else {
        query.ymsContainerStatusIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsContainerStatus_shelvesOrderExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 根据状态处理列表字段和筛选条件
    handleFilter(data) {
      let v = this;
      v.tableColumns = [];
      v.dropDownTimeList = [];
      let filterTimeList = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'), value: 1, parameterKey: ['workStartTimeUp', 'workStartTimeDown']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'), value: 2, parameterKey: ['workEndTimeUp', 'workEndTimeDown']}
      ];
      data.map((item) => {
        if (item.selected) {
          if (item.value === 6) {
            v.tableColumns = v.shelvesTableColumns;
            v.dropDownTimeList = [];
            v.$forceUpdate();
          } else if (item.value === 7) {
            v.tableColumns = v.shelvesingTableColumns;
            v.dropDownTimeList = filterTimeList.slice(0, 1);
            v.$forceUpdate();
          } else {
            v.tableColumns = v.shelvesedTableColumns;
            v.dropDownTimeList = filterTimeList;
            v.$forceUpdate();
          }
        }
      });
    },
    // 查询当前登录的用户是否有正在上架中的操作
    getShelvesOptions() {
      let v = this;
      v.axios.get(api.get_ymsContainerStatus_getShelvesingOrder + `?userId=${v.userInfo.userId}`).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let code = data.code;
            if (code && v.getPermission('ymsContainerStatus_shelvesDetail')) {
              v.$Modal.confirm({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004068'),
                content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004069'),
                onOk: () => {
                  let url = api.get_ymsContainerStatus_startShelves + `?code=${code}`;
                  v.$refs['commodityShelves'].initCommodityShelvesData(url);
                },
                onCancel: () => {
                }
              });
            }
          }
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        if (v.pageParams.status === 6) {
          v.getShelvesList();
        } else if (v.pageParams.status === 7) {
          v.getShelvesingList();
        } else if (v.pageParams.status === 8) {
          v.getShelvesedList();
        }
        v.pageParamsStatus = false;
      }
    },
    // 监听容器状态
    containerStatusList: {
      handler(data) {
        let v = this;
        v.handleFilter(data);
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    dropDownDateTime,
    exportFieldsModal,
    commodityShelvesModal
  }
};
</script>

<style lang="less" scoped>
.filter_box /deep/ .ivu-form-item {
  margin: 0 !important;
}

.content_box {
  padding: 15px 15px 10px 15px;
  background-color: #fff;
  border-radius: 3px;
}

.table_box {
  background-color: #fff;

  /deep/ .ivu-tabs-bar {
    padding: 0 25px;
  }

  /deep/ .ivu-table-cell-slot {
    padding-top: 24px;
  }

  /deep/ .ivu-tabs-content {
    padding: 10px 25px 25px 25px;
  }
}
</style>
